var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 31",
    "data-xds": "LogoXINGLogoDuo",
    height: 28,
    width: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#clip0_47_1328)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m1.805 5.984 3.635 6.479L0 22.018h6.491l5.4-9.555-3.634-6.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m21.122 0-10.49 18.642L17.396 31h6.582l-6.88-12.358L27.6 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXingIcon);
export default __webpack_public_path__ + "static/media/xing_icon.ec0b28425df3fb0a4d579542f42625bd.svg";
export { ForwardRef as ReactComponent };